import { render } from "./VideoLayout.vue?vue&type=template&id=69384aec&scoped=true"
import script from "./VideoLayout.vue?vue&type=script&lang=js"
export * from "./VideoLayout.vue?vue&type=script&lang=js"

import "./VideoLayout.vue?vue&type=style&index=0&id=69384aec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69384aec"]])

export default __exports__